import { jsxs as o, jsx as s, Fragment as c } from "react/jsx-runtime";
import d from "classnames";
import '../../assets/ProgressIndicator.css';const i = "_meter_17vgr_8", m = "_label_17vgr_11", n = "_progress_17vgr_2", e = {
  "progress-indicator": "_progress-indicator_17vgr_2",
  meter: i,
  label: m,
  progress: n
}, p = ({ id: t, progress: r = 0, label: a, className: l }) => /* @__PURE__ */ o("div", { "data-testid": "progress-indicator", className: d(e["progress-indicator"], l), children: [
  !!a && /* @__PURE__ */ o(c, { children: [
    /* @__PURE__ */ s("label", { htmlFor: t, className: e.label, "data-testid": "label", children: a }),
    /* @__PURE__ */ s("data", { value: r, className: e.progress, "data-testid": "progress", children: `${r}%` })
  ] }),
  /* @__PURE__ */ s("progress", { id: t, "data-testid": "meter", className: e.meter, role: "meter", value: r, max: 100 })
] });
export {
  p as default
};
